export const backdropAndUnscroll = isMenuOpen => {
  const html = document.querySelector("html")
  if (!isMenuOpen) {
    html.style.overflowY = "hidden"
  } else {
    html.style.overflowY = "visible"
  }
}
